import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent, Register } from '@xanadu/core';
import { Category } from '@xanadu/model';

@Component({
    selector: 'app-category-panel',
    templateUrl: './category-panel.component.html',
    styleUrls: ['./category-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('category-panel')
export class CategoryPanelComponent extends PanelComponent<Category> {
    private tabContent = { caption: 'Category', active: true, hidden: false };


    protected override get nodeType(): string | undefined {
        return 'type';
    }

    protected override setup(category: Category): void {
        super.setup(category);

        this.tabs = [
            this.tabContent
        ];

        this.tabSelected = this.tabContent;
    }
}
